import React from 'react'
import { FooterNewLP } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { LoanRefinanceScreen } from '../screens/loan-refinance'

const LoanPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	LoanRefinanceScreen({
		ratePoints: [
			'Ставка по рефинансированию — от 14,9% годовых',
			'Можно рефинансировать даже залоговый кредит от другого банка',
			'Снизим платёж за счёт длительного срока рефинансирования до 20 лет',
			'Не нужно платить комиссии кредитному брокеру, так как рефинансирование без посредников',
			'Одобрение за 30 минут без подтверждения дохода',
		],
		minLoan: 1e6,
	})

LoanPage.layout = PageLayout
LoanPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterNewLP />,
}

LoanPage.headProps = {
	canonicalLink: 'https://credit.club/personal/na-refinansirovanie',
	title: pagesTitles[PagesPath.loanRefinance].title,
	description:
		'От 1 миллиона рублей ► Конкурентная ставка ► До 15 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'graph-loan.jpg',
}

export default LoanPage
